import './index.styl'
import Menu from './menu'
import React from 'react'
import { Table, Button, Row, Col } from 'react-bootstrap'
import HeaderRow from './header-row'
import moment from 'moment'


class Component extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selected: [],
      reportDisabled: false,
      start: '',
      end: '',
    }
  }

  componentWillMount () {
    const { type, project, actions, segment, headers } = this.props

    if (type === null) {
      actions.push('/')
      return
    }

    if (project === null) {
      actions.push('/projects')
      return
    }

    if (type === 'segments' && segment === null) {
      actions.push('/segments')
      return
    }

    this.setState({ selected: headers })
  }

  saveReport () {
    const { project, type, segment, actions } = this.props
    const name = window.prompt('Kies een naam voor uw rapportage')

    if (typeof name !== 'string' || name.trim() === '') {
      return
    }

    actions.setHeaders([...this.state.selected])
    actions.createReport({
      name,
      project,
      type,
      segment,
      headers: [...this.state.selected]
    })

    this.setState({ reportDisabled: true })
  }

  headers () {
    let headers = {}
    const { type, me } = this.props

    if (type === 'suppliers') {
      headers = {
        'name': 'Naam',
        'contact': 'Contactpersoon',

      }
    }

    if (type === 'orders_by_order' || type === 'orders_by_line') {
      headers = {
        'orderDate': 'Datum',
        'orderNumber': 'Ordernummer',
        'status': 'Orderstatus',
        'denyReason': 'Reden voor afwijzing',
        'paymentPercentage': 'Percentage bijbetaling',
        'orderSubtotal': 'Subtotaal',
        'orderVat': 'BTW',
        'orderTotal': 'Totaal',
        'orderCredits': 'Punten',
        'user.customerUserId': 'Gebruikersnummer',
        'user.id': 'Gebruiker ID',
        'user.role': 'Rol gebruiker',
        'user.accessLevel': 'Gebruikersniveau',
        'deliveryAddress.address1': 'Adres 1 (verzending)',
        'deliveryAddress.address2': 'Adres 2 (verzending)',
        'deliveryAddress.postcode': 'Postcode (verzending)',
        'deliveryAddress.city': 'Stad (verzending)',
        'deliveryAddress.name': 'Volledige naam (verzending)',
        'deliveryAddress.organisation': 'Organisatie (verzending)',
        'deliveryAddress.phone': 'Telefoon (verzending)',
        'deliveryAddress.email': 'Email (verzending)',
        'invoiceAddress.address1': 'Adres 1 (factuur)',
        'invoiceAddress.address2': 'Adres 2 (factuur)',
        'invoiceAddress.postcode': 'Postcode (factuur)',
        'invoiceAddress.city': 'Stad (factuur)',
        'invoiceAddress.name': 'Volledige naam (factuur)',
        'invoiceAddress.organisation': 'Organisatie (factuur)',
        'invoiceAddress.phone': 'Telefoon (factuur)',
        'invoiceAddress.email': 'Email (factuur)',
        'userAgent': 'Browser ID',
        'reviewedAt': 'Review datum',
      }
    }

    if (type === 'orders_by_line') {
      headers['orderLines..variant.brand'] = 'Merk (orderregel)'
      headers['orderLines..product.title'] = 'Titel (product, orderregel)'
      headers['orderLines..variant.title'] = 'Titel (variant, orderregel)'
      headers['orderLines..variant.subtitle'] = 'Ondertitel (orderregel)'
      headers['orderLines..variant.sku'] = 'SKU (orderregel)'
      headers['orderLines..quantity'] = 'Aantal (orderregel)'
      headers['orderLines..calculated.vat'] = 'BTW (orderregel)'
      headers['orderLines..calculated.subtotal'] = 'Prijs (orderregel)'
      headers['orderLines..calculated.total'] = 'Prijs (orderregel)'

      if (me.role === 'superuser' || me.accessLevel >= 100) {
        headers['orderLines..supplier.name'] = 'Leverancier (orderregel)'
      }
    }

    if (type === 'users' || type === 'segments') {
      headers = {
        'id': 'Gebruiker ID',
        'customerUserId': 'Gebruikersnummer',
        'email': 'Emailadres/gebruikersnaam',
        'active': 'Actief',
        'firstLogin': 'Onboarding aan/uit',
        'role': 'Rol gebruiker',
        'accessLevel': 'Gebruikersniveau',
        'totalCredits': 'Punten (niet altijd beschikbaar)',
        'profile.firstName': 'Voornaam',
        'profile.lastName': 'Achternaam',
        'profile.organisation': 'Organisatie',
        'profile.address1': 'Adres',
        'profile.postcode': 'Postcode',
        'profile.city': 'Stad',
        'profile.phone': 'Telefoonnummer',
        'profile.generalTerms': 'Akkoord AV (Uniprime)',
        'profile.boughtAt': 'Gekocht bij (Uniprime)',
        'profile.sticker': 'Sticker (Uniprime)',
        'profile.receipt': 'Bon (Uniprime)'
      }
    }

    if (type === 'products') {
      headers = {
        'products': 'Producten + marge'
      }
    }

    if (type.indexOf('campaign') !== -1) {
      headers = {
        'all': 'Alle data'
      }
    }

    if (type === 'credits_by_user') {
      headers = {
        'customerUserId': 'Klantnummer',
        'balance': 'Saldo',
        'lastDebitTransaction': 'Laatste debittransactie',
        'lastCreditTransaction': 'Laaste credittransactie',
      }
    }

    if (type.indexOf('budget') !== -1) {
      headers = {
        'all': 'Alle data'
      }
    }

    if (Object.keys(headers).length === 0) {
      headers = {
        'all': 'Alle data'
      }
    }

    return headers
  }

  toggleAll () {
    if (this.state.selected.length > 0) {
      this.setState({ selected: [] })
      return
    }

    this.setState({
      selected: Object.keys(this.headers())
    })
  }

  toggleSelectHeader (id) {
    const selected = [...this.state.selected]

    if (selected.includes(id)) {
      selected.splice(selected.indexOf(id), 1)
    } else {
      selected.push(id)
    }

    this.setState({ selected })
  }

  export () {
    if (this.state.selected.length === 0 && this.props.type !== 'credits_transactions') {
      return
    }

    const { project, type, segment, actions } = this.props
    const headers = [...this.state.selected]
    const CODE = 'dace5395-0d42-44de-8882-3cb846d629f9'

    actions.setHeaders(headers)
    actions.push('/')

    if (type === 'credits_transactions') {
      let start = this.state.start.trim() === '' ? '1970-01-01T00:00:00.000Z' : this.state.start.trim()
      let end = this.state.end.trim() === '' ? 'now' : this.state.end.trim()

      start = moment(start).startOf('day').toISOString()
      end = moment(end).endOf('day').toISOString()

      return window.open(`http://credits.iloyaltyserver.nl/export?start=${start}&end=${end}&projectId=${project}`)
    }

    if (type === 'users') {
      return window.open(`https://sso0.iloyalty.io/api/1/user/98a42d183559?code=${CODE}&project=${project}&type=${type}&headers=${headers.join('|')}`)
    }

    if (type === 'segments' && typeof segment === 'string') {
      return window.open(`https://sso0.iloyalty.io/api/1/user/98a42d183559?code=${CODE}&project=${project}&type=${type}&headers=${headers.join('|')}&segment=${segment}`)
    }

    if (type === 'products') {
      return window.open(`https://shop0.iloyalty.io/api/1/product/beff46acde92?code=${CODE}&project=${project}&type=${type}&headers=${headers.join('|')}`)
    }

    if (type === 'orders_by_order' || type === 'orders_by_line') {
      window.open(`https://shop0.iloyalty.io/api/1/order/beff46acde92?code=${CODE}&project=${project}&type=${type}&headers=${headers.join('|')}`)
    }

    if (type === 'suppliers') {
      window.open(`https://shop0.iloyalty.io/api/1/supplier/beff46acde92?code=${CODE}&project=${project}&type=${type}&headers=${headers.join('|')}`)
    }

    if (type === 'credits_by_user') {
      window.open(`http://credits.iloyaltyserver.nl/export/balance?projectId=${project}`)
    }

    if (type === 'campaign_giveaway_stats' || type === 'campaign_giveaway_submissions') {
      window.open(`http://api.iloyaltyserver.com/api/v1/campaign/export?type=${type.replace('campaign_giveaway_', '')}&project=${project}`)
    }

    if (type === 'budget_totals' || type === 'budget_transactions') {
      window.open(`http://api.iloyaltyserver.com/api/v1/budget/export?type=${type.replace('budget_', '')}&project=${project}`)
    }
  }

  render () {
    const { type, project, actions, headers } = this.props
    const col0 = []
    const col1 = []
    const columns = this.headers()

    Object.keys(columns).forEach((id, index) => {
      if (col0.length < Math.ceil(Object.keys(columns).length / 2)) {
        col0.push(<HeaderRow key={index} id={id} name={columns[id]} selected={this.state.selected.includes(id)} click={() => { this.toggleSelectHeader(id) }} />)
      } else {
        col1.push(<HeaderRow key={index} id={id} name={columns[id]} selected={this.state.selected.includes(id)} click={() => { this.toggleSelectHeader(id) }} />)
      }
    })

    if (type === 'credits_transactions') {
      col0.push(
        <div className="form-group" key="startdatum">
          <label>Startdatum (YYYY-MM-DD)</label>
          <input type="text" className="form-control" placeholder="2017-07-01" value={this.state.start} onChange={(e) => { this.setState({ start: e.target.value }) }} />
        </div>
      )

      col0.push(
        <div className="form-group" key="einddatum">
          <label>Einddatum (YYYY-MM-DD)</label>
          <input type="text" className="form-control" placeholder="2017-07-02" value={this.state.end} onChange={(e) => { this.setState({ end: e.target.value }) }} />
        </div>
      )
    }

    return (
      <main>
        <section className="container padding-top">
          <Row className="modifiers align-right">
            <Col xs={12}>
              <a className="btn btn-primary-outline" onClick={() => { this.toggleAll() }}>(De)selecteer alles</a>
              <a className={ (this.state.selected.length === 0 || this.state.reportDisabled === true) ? 'btn btn-primary-outline disabled' : 'btn btn-primary-outline' } onClick={() => { this.saveReport() }}>Rapport opslaan</a>
              <a className={ (this.state.selected.length > 0 || type === 'credits_transactions') ? 'btn btn-primary' : 'btn btn-primary disabled' } onClick={() => { this.export() }}>Exporteren</a>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              {col0}
            </Col>

            <Col xs={6}>
              {col1}
            </Col>
          </Row>
        </section>
      </main>
    )
  }
}

export default Component



// WEBPACK FOOTER //
// ./components/Headers/index.js